import { v4 as uuidv4 } from "uuid";
import IMG from "../Images/thumbnail.png";
export const data = [
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
  {
    id: uuidv4(),
    thumbnail: IMG,
    project: "Landing Page Design",
    type: "UI design",
  },
];
